module.exports = __webpack_public_path__ + "img/hsyy.f3b0addb.png";